module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fm-title"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Praise for")])]), _vm._v(" "), _c('h2', {
    staticClass: "fm-title1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Dark Lie")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Nancy Springer’s first foray into suspense is a darkly riveting read, featuring a scarred heroine whose past is shrouded in a shameful secret she would kill—or die—to protect. The pages swiftly fall away, along with layers of secrets and lies, to reveal the pulsing heart of this compelling thriller: the primal bonds between parent and child, between man and woman—and the fine line between love and hate.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—Wendy Corsi Staub, national bestselling author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nightwatcher")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sleepwalker")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“A fast-paced, edge-of-your-seat thriller that will have you reading late into the night and cheering for the novel’s unlikely but steadfast heroine, Dorrie White.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—Heather Gudenkauf, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New York Times")]), _vm._v(" bestselling author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Weight of Silence")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("These Things Hidden")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“A page-turner of a thriller with a truly unique and fascinating heroine. I found myself rooting for Dorrie White as she was forced to confront not only a brutal killer but the dark secrets of her past.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—Alison Gaylin, national bestselling author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("And She Was")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a20ced54","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Fm.vue
// module id = 72
// module chunks = 0